module.exports = __webpack_public_path__ + "img/30.c0e8129a.png";